import '/assets/styles/pages/web-menu.scss';

// Partials
import Loader from '/views/partials/loader';

// Sections
import WebPageHeader from '/views/sections/web-page-header';
import OrderLookup from '/views/sections/order-lookup';

// Context
import { useApplication } from '/utilities/application';
import { useTranslation } from '/utilities/i18n';
import { useNavigator } from '@wearetla/tla-essentials-tools/utilities/navigator';
import { useLocation } from 'react-router-dom';
import { useEffect } from 'react';

const WebOrderLookup = () => {
	const { isApplication } = useApplication();
	const { redirect, getRoutePath } = useNavigator();
	const { search } = useLocation();
	const { t } = useTranslation();

	useEffect(() => {
		if (isApplication && search) {
			// Sorgu parametreleri uygulama içi sayfaya olduğu gibi aktarılır.
			redirect(`${getRoutePath('orderLookup')}${search}`, null, { raw: true });
		}
	}, [search, isApplication]);

	return (
		<>
			<Loader full solid dark loading={isApplication} />
			{!isApplication &&
				<>
					<WebPageHeader backLink={false} title={t('Sipariş Sorgulama')} />
					<OrderLookup />
				</>
			}
		</>
	);
};

export default WebOrderLookup;
